import omit from 'lodash/omit';
import omitBy from 'lodash/omitBy';
import pick from 'lodash/pick';
import isNil from 'lodash/isNil';
import pipe from 'lodash/fp/pipe';
import { USE_SERVICE_DURATION_FOR_TIMES } from '../../main/barbers/constants';
import { prepareMinsForSaving } from './schedules';

export const minServiceLenModel = (model, minInterval) => {
  const useServiceDurationForTimes = model.minServiceLen && model.minServiceLen === USE_SERVICE_DURATION_FOR_TIMES;
  const minServiceLen = useServiceDurationForTimes ? minInterval : model.minServiceLen;
  return { ...model, useServiceDurationForTimes, minServiceLen };
};

const optionalNonNil = (model, property) => {
  const prop = omitBy(pick(model, property), isNil);
  return { ...omit(model, property), ...prop };
};

export const barberPhoneOptional = model => optionalNonNil(model, 'phone');
export const barberEmailOptional = model => optionalNonNil(model, 'email');
export const barberDefaultServiceOptional = model => optionalNonNil(model, 'defaultServiceId');
export const barberOptionalFields = pipe(barberPhoneOptional, barberEmailOptional, barberDefaultServiceOptional);
export const daysOffOptional = model => (model.id ? omit(model, ['days_off']) : model);

export const prepareForSaving = (barber, minInterval) => {
  const model = minServiceLenModel({ ...barber }, minInterval);
  model.advanceBookMins = prepareMinsForSaving(model.advanceBookMins);
  model.advanceCancelMins = prepareMinsForSaving(model.advanceCancelMins);
  model.customerReminder.barber_reminder.time = prepareMinsForSaving(model.customerReminder.barber_reminder.time);
  model.customerReminder.reminder.time = prepareMinsForSaving(model.customerReminder.reminder.time);
  return model;
};
